import React, {useState, useContext} from 'react';
import { Grid } from "@material-ui/core";
import { FormSelect, Form, Alert, FormCheckbox } from '../../../../controls';
import SystemContext from "../../../../SystemContext";
import TariffChargeCodesValidator from "../../validators/TariffChargeCodesValidator";
import { useUpdateComboValue } from "../../../../services/settings";

const ComboDetailsForm = (_props) => {
  const props = { 
    canEdit: false,   
    ..._props
  }

  const classes = props.classes;
  const [comboRecord, setComboRecord] = useState(props.comboRecord);
  const defaultRecord = {
    chargeGroupCode:'ADDITONAL',
    calculationType:'UNIT',
    unitType: 'QUANTITY',
    requestAmount: false
  }
  const [record, setRecord] = useState({...defaultRecord, ...(props.comboRecord?props.comboRecord.data:null)});
  const [editing, setEditing] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    severity: "error",
    message: ""
  });

  if (props.comboRecord && (props.comboRecord.comboValueUuid !== comboRecord.comboValueUuid)) {
    setRecord(props.comboRecord.data);
    setComboRecord(props.comboRecord);
    setEditing(false);
  }

  const SystemData = useContext(SystemContext);

  const handleUpdateComboValue = useUpdateComboValue();

  const extraKeys = []; //props.comboRecord.comboValueUuid

  const chargeGroupCodeOptions = [{"code":"CARGO","value":"Cargo Charges"},{"code":"ADDITIONAL","value":"Additional Charges"}];
  const calculationTypeOptions = [{"code":"UNIT","value":"Unitised"},{"code":"FIXED","value":"Fixed"}];
  const unitTypesOptions = [
    {"code":"PIECES","value":"Pieces"},
    {"code":"WEIGHT","value":"Weight"},
    {"code":"CHARGEABLE_WEIGHT","value":"Chargeable Weight"},
    {"code":"QUANTITY","value":"Quantity"},
  ];

  return (
    <div key="formContainer" style={{width: "100%", textAlign:"left"}}>
      <Alert
        key="alert"
        onChange={(open) => {
          setAlert({ ...alert, open })
        }}
        open={alert.open}
        severity={alert.severity}
        message={alert.message}
        timeOut={alert.timeOut || 0}
      />
      {record ?
      <Form key="form"
        message=""
        open={true}
        record={record}
        validator={editing?TariffChargeCodesValidator:null}
        formBodyStyle={{maxHeight: "calc(100vh - 320px)"}}
        buttonBarStyleOverride={{position: "relative", width: "calc(100% - 30px)", marginTop: -30}}
        buttons = {editing?
          {
            save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{return status.error}}, 
            cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
          }: props.canEdit?{
            edit: {icon: "edit", key: "Edit", label: "Edit", color: "primary"}
          }: {}
        }
      
        onChange={(state) => {
          if (state.buttonPressed === "edit" && props.canEdit) {
            setEditing(true);
          }
          if (state.buttonPressed === "cancel") {
            setEditing(false);
            setRecord({...defaultRecord, ...(props.comboRecord?props.comboRecord.data:null)});
          }
          if (state.buttonPressed === "save") {
            SystemData.toggleLoadingProgress(true);
            const record = state.record;
            handleUpdateComboValue.mutate({
              extraKeys,
              record: {...comboRecord, data: {...record}}, 
              postSuccess: () => {
                setEditing(false);
                SystemData.toggleLoadingProgress(false);
                setAlert({ severity: "info", open: true, message: "Record Updated", timeOut: 5 });
              },
              postError: (data) => {
                SystemData.toggleLoadingProgress(false);
                if (data.errorMessage) {
                  SystemData.alert("Error", `${data.errorMessage}`);
                } else {
                  SystemData.alert("Error", `An Unexpected Error has occurred creating the trip.`);
                }
              }
            });
          } else {
          }
        }}
      >
        <Grid container checkChildren={true} spacing={3}>
          <Grid item xs={3} checkChildren={true}>
            <FormSelect 
              id="chargeGroupCode"
              label="Charge Group"
              options={chargeGroupCodeOptions}
              readOnly={editing!==true}
            />
          </Grid>    
          <Grid item xs={3} checkChildren={true}>
            <FormSelect 
              id="calculationType"
              label="Calculation Type"
              options={calculationTypeOptions}
              readOnly={editing!==true}
            />
          </Grid>  
          {(record) => {return (record.calculationType === "FIXED")?<></>:  
          <Grid item xs={3} checkChildren={true}>
            <FormSelect 
              id="unitType"
              label="Unit Type"
              options={unitTypesOptions}
              readOnly={editing!==true}
            />
          </Grid>    
          }}
          {(record) => {return (record.calculationType === "FIXED")?<></>:  
          <Grid item xs={3} checkChildren={true}>
            <FormCheckbox 
              id="requestAmount"
              label="Request Amount"
              key="requestAmount"
              className={classes.checkbox}
              readOnly={editing!==true}
            />
          </Grid>    
        }}
        </Grid>
      </Form>
      :<div>Loading ...</div>
    }
    </div>
  );
}

export default ComboDetailsForm;
